export function stripWhitespace(string: string) {
    return string.replace(/\s+/g, '')
}

export function stripNonDigits(string: string) {
    let copy = string
    copy = copy.replace(/(\W)/g, '');
    copy = stripWhitespace(copy)    
    return copy
}

export function capitalize(value: string) {
    if (typeof value !== 'string') return ''
    return value.charAt(0).toUpperCase() + value.slice(1)
}